var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.records)?_c('span',[_vm._v(" "+_vm._s(_vm.count)+" "+_vm._s(_vm.count === 1 ? _vm.name : (_vm.name + "s"))+" ")]):_c('span',[_vm._v("-")])])}
var staticRenderFns = []

export { render, staticRenderFns }